import { useRequest } from '../providers/useRequest';

import AppError from '../../errors/AppError';
import ITimeRecord from '../../interfaces/ITimeRecord';

interface IFilterFollowup {
  employeeId: number | null;
}

const useTimeRecordService = () => {
  const timeRecordsRequest = useRequest<ITimeRecord[]>();
  const path = 'point-control/time-record';

  let storage = sessionStorage.getItem('user');

  if (!storage) {
    storage = localStorage.getItem('localSettings');
  }

  const data = JSON.parse(storage ?? '');

  const tenantDomain = data.tenantDomain.replace('.', '_').replace('.', '_');

  const listByEmployeeAndDateTimeRecords = async (
    initialDate: string,
    endDate: string,
    employeeId: number,
  ): Promise<any> => {
    return await timeRecordsRequest
      .getOne({
        path: `${path}/list-by-employee-and-date/${initialDate}/${endDate}/${employeeId}`,
        headers: { tenantDomain: tenantDomain },
        sendAuthorization: false,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listByDateTimeRecords = async (
    initialDate: string,
    endDate: string,
    filters: IFilterFollowup,
  ): Promise<any> => {
    return await timeRecordsRequest
      .post({
        path: `${path}/list-by-date/${initialDate}/${endDate}`,
        headers: { tenantDomain: tenantDomain },
        sendAuthorization: false,
        body: { ...filters },
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const createTimeRecord = async (resource: ITimeRecord) => {
    return await timeRecordsRequest
      .post({
        path: `${path}`,
        headers: { tenantDomain: tenantDomain },
        sendAuthorization: false,
        body: resource,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const findTimeRecord = async (date: string | undefined, employeeId: number, action: string[]): Promise<any> => {
    return await timeRecordsRequest
      .getOne({
        path: `${path}/find-by-date/${date}/${employeeId}/${action}`,
        headers: { tenantDomain: tenantDomain },
        sendAuthorization: false,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const removeTimeRecord = async (id: string) => {
    return await timeRecordsRequest
      .remove({
        path: `${path}/${id}`,
        headers: { tenantDomain: tenantDomain },
        sendAuthorization: false,
      })
      .then(() => {})
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const updateStatusTimeRecord = async (employeeId: number, date: string, status: string) => {
    return await timeRecordsRequest
      .put({
        path: `${path}/update/status`,
        sendAuthorization: true,
        body: {
          employeeId,
          date,
          status,
        },
      })
      .then(() => {})
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  return {
    listByEmployeeAndDateTimeRecords,
    listByDateTimeRecords,
    findTimeRecord,
    removeTimeRecord,
    createTimeRecord,
    updateStatusTimeRecord,
  };
};

export { useTimeRecordService };
